import { createFileRoute } from "@tanstack/react-router"
import { AiSettingsCard } from "~/components/settings/AiSettingsCard"

export const Route = createFileRoute("/_auth/settings/_layout/ai")({
  component: AiSettingsCard,
})
